/**
 * @author Yaochao
 * @date 2021/7/12 13:44
 * @description search中input组件封装
 */

import React, {useEffect, useState} from "react";
import {Input, Select} from "antd";
import {useInputValue, userInputOnKeyDown} from "../input/useInput";

/**
 *
 * @param title 字段描述
 * @param valueKey value的key
 * @param setSearchParams 父组件传递，无需设置
 * @param resetFlag 父组件传递，无需设置
 * @param placeholder input的placeholder
 * @returns {*}
 * @constructor
 */
export const ZkInput = (props) => {
    const {title: title, valueKey: valueKey, setSearchParams: setSearchParams, setDefaultSearchParams: setDefaultSearchParams, resetKeys: resetKeys, placeholder: placeholder, linkage: linkage} = props;
    const [value, setValue] = useState('');
    const [inputValueChange] = useInputValue(onChange);
    const [onKeyDown] = userInputOnKeyDown(onKeyDownCallback);

    useEffect(()=>{
        onChange(props.defaultValue)
    },[props.defaultValue])
    /**
     * value值变化处理，并把值通过setSearchParams传递给父组件
     * @param val
     */
    function onChange(val) {
        if (valueKey) {
            //不是联动查询
            if (!linkage) {
                setSearchParams({[valueKey]: val});
            } else if (val != undefined && val.length == 0) {
                setSearchParams({[valueKey]: val});
            }
            setValue(val);
        }
    }

    function onKeyDownCallback() {
        if (linkage) {
            setSearchParams({[valueKey]: value});
        }
    }

    /**
     * 向group传递默认值
     */
    useEffect(() => {
        if (valueKey) {
            setDefaultSearchParams({[valueKey]: ''});
        }
    }, []);

    useEffect(() => {
        if (resetKeys.indexOf(valueKey) != -1) {
            setValue('')
        }
    }, [resetKeys]);

    return (
        <li className='sg-item'>
            <label className='sg-item-title'>{title}</label>
            <div className='sg-item-wraper'>
                <Input allowClear={true} value={value} onChange={inputValueChange} placeholder={placeholder}
                       onPressEnter={onKeyDownCallback}></Input>
            </div>
        </li>
    )
};

export default ZkInput